import { useCurrentUser } from 'FrontRoyalAngular';
import { useAppHeaderViewModel } from 'NavigationHelpers';
import { Chat } from 'TutorBotChat';
import { memo } from 'react';
import { AI_ADVISOR_BRAND_NAME } from '../constants';
import { useBotPageGreetingConfig } from '../useBotPageGreetingConfig';
import { useBotPageStatusConfig } from '../useBotPageStatusConfig';
import { type BotPageClientContext } from '../TutorBotAiAdvisorChat.types';

const clientContext: BotPageClientContext = {
    uiContext: 'bot_page',
};

export function BotPageComponent() {
    const currentUser = useCurrentUser()!;
    const AppHeaderViewModel = useAppHeaderViewModel();
    const botName = AI_ADVISOR_BRAND_NAME;

    AppHeaderViewModel.showAlternateHomeButton = false;
    AppHeaderViewModel.setTitleHTML(botName.toLocaleUpperCase());
    const tutorBotStatusConfig = useBotPageStatusConfig();
    const greetingMessageConfig = useBotPageGreetingConfig(tutorBotStatusConfig);

    return (
        <div
            className="relative h-full w-full overflow-hidden bg-slate-grey-100-alt pt-[1px]"
            style={{ '--chat-scroll-haze-color': '#F2F3F5' } as React.CSSProperties}
        >
            <div className="relative mx-auto h-full w-full max-w-full px-3.5 sm:w-[750px] md:w-[970px] lg:w-[1170px]">
                <Chat
                    botName={botName}
                    tutorBotStatusConfig={tutorBotStatusConfig}
                    greetingMessageConfig={greetingMessageConfig}
                    currentUser={currentUser}
                    clientContext={clientContext}
                    endConversationOnClose
                    enableSetNewTopic
                />
            </div>
        </div>
    );
}

export const BotPage = memo(BotPageComponent);
